const closureReasons = [
  { value: 'unhappy_with_interest_rate', label: 'I\'m unhappy with the interest rate' },
  { value: 'unhappy_with_service', label: 'I\'m unhappy with the service or product features' },
  { value: 'prefer_app_management', label: 'I would prefer to manage my account via an app' },
  { value: 'moving_to_isa', label: 'I\'m moving funds to an ISA product' },
  { value: 'balance_below_minimum', label: 'My balance is below the minimum amount of £5,000' },
  { value: 'need_money_other_purpose', label: 'I need the money for another purpose' },
  { value: 'no_longer_use', label: 'I no longer use or need the account' },
  { value: 'no_longer_eligible', label: 'I\'m no longer eligible (e.g. not a UK resident)' },
  { value: 'wrong_account', label: 'I opened the wrong account by mistake' },
  { value: 'other', label: 'Other' },
];

export default closureReasons;